"use strict";

angular.module('app.userlogin')
    .factory("loginService", loginService);

loginService.$inject = ['$http', '$q', 'httpRequest', 'appGlobals'];

function loginService($http, $q, httpRequest, appGlobals) {
    var baseurl = appGlobals.baseApiUrl;
    var baseciurl = appGlobals.baseApiUrl;
    var users = null;
    var locations = null;
    var scheme = null;

    //var requestUsers = function () {
    //    var url = baseurl + "persons" + "?include=users, PersonDetails, users.UserGroups, users.UserGroups.UserLocGroups";
    //    return httpRequest.doGetRequest(url, null).promise;
    //};

	var loginInit = function () {
		var url = appGlobals.baseApiUrl + "login/loginInit";
		return httpRequest.doGetRequest(url);
	};

	var loginUser = function (userid, pwd, acceptBeta, useWinAuth) {
		if (useWinAuth == false) {
			var deferred = $q.defer();
			encrypt(pwd, function (encryptPwd) {
				var loginObj = { UserID: userid, Password: encryptPwd, AcceptBeta: acceptBeta, UseWinAuth: false };
				var url = baseurl + "login/userLogin";
				httpRequest.doPostRequest(url, loginObj).then(function (data) {
					deferred.resolve(data);
				}, function (error) { deferred.reject(error); });
			});
			return deferred.promise;
		}
		else {
			var url = baseurl + "login/userLogin";
			var loginObj = { UserID: userid, Password: null, AcceptBeta: acceptBeta, UseWinAuth: true };
			return httpRequest.doPostRequest(url, loginObj);
		}
	};

    var requestScheme = function () {
        var url = appGlobals.baseApiUrl + "LoginScheme";
		return httpRequest.doGetRequest(url);
    };

    //var schemePromise = requestScheme(schemeSuccess, schemeError);

    function schemeSuccess(response) {
        scheme = response;
    }

    function schemeError(response) {
        console.log(response);
    }

    //var allPromises = $q.all([/*usersPromise, locationsPromise*/, schemePromise]);

    var validateLogin = function (userid, pwd, acceptBeta) {
        var deferred = $q.defer();
        encrypt(pwd, function (encryptPwd) {
            var url = baseurl + "users/userlogin/" + userid + "/" + encryptPwd + "/" + acceptBeta;
            httpRequest.doGetRequest(url).then(function (data) {
                deferred.resolve(data);
            }, function (error) { deferred.reject(error); });
        });
        return deferred.promise;
    };

    var acceptBeta = function (userID) {
        var url = baseurl + "users/UserAcceptBeta/" + userID;
		return httpRequest.doPostRequest(url);        
    };

    return {
        //allPromises: allPromises,
        //getUsers: function () {
        //    return users;
        //},
        //getLocations: function () { return locations; },
		loginInit: loginInit,
		loginUser: loginUser,
        requestScheme: requestScheme,
        getScheme: function () { return scheme; },
        validateLogin: validateLogin,
        acceptBeta: acceptBeta
    };

};

/*###############################################################################################################################
Encrypt function
Author: Josh Doran
Company: aSa
Purpose: encrypt a cleartext string using RSA and the public key provided
method: 1. retrieve the key from the XML file
        2. encrypt the string
        3. return the encrypted string to the caller

dependencies: all located in the /scripts folder
              base64.js
              ec.js
              jsbn.js
              jsbn2.js
              prng4.js
              rng.js
              rsa.js
              rsa2.js
              sec.js
###############################################################################################################################*/
function encrypt(clearText, callback) {
    var key_1024 = {};
    key_1024.n = "";
    key_1024.e = "";

    var jqxhr = $.get("app/login/Public.xml", function () { })
        .done(function (xml) {
            $(xml).find('RSAKeyValue').each(function () {
                key_1024.n = $(this).find('Modulus').text();
                key_1024.e = $(this).find('Exponent').text();
            });
            var rsa = new RSAKey();
            var hexn = b64tohex(key_1024.n);
            var hexe = b64tohex(key_1024.e);
            rsa.setPublic(hexn, hexe);
            var res = rsa.encrypt(clearText);
            callback(res);
        });
}